var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaution = function SvgCaution(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".caution_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.553 22.581a.569.569 0 0 1-.553.894H2a.569.569 0 0 1-.553-.894L11.553 2.37c.246-.492.648-.492.894 0ZM12 16.979v-7",
    className: "caution_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.991 18.979a.246.246 0 0 0-.241.255.255.255 0 0 0 .254.245h.005a.246.246 0 0 0 .241-.255.255.255 0 0 0-.25-.245h-.005",
    className: "caution_svg__a"
  })));
};
export default SvgCaution;